import React, { useState, createContext, useContext, useEffect } from 'react';
import Layout from './components/Layout';
import Header from './components/Header';
import HeroSection from './components/HeroSection';
import VisionMissionSection from './components/VisionMissionSection';
import CoreValuesSection from './components/CoreValuesSection';
import StructureSection from './components/StructureSection';
import GuidingPrinciplesSection from './components/GuidingPrinciplesSection';
import CallToActionSection from './components/CallToActionSection';
import CreativeCirclesSection from './components/CreativeCirclesSection';
import MembershipSection from './components/MembershipSection';
import PrinciplesCarousel from './components/PrinciplesCarousel';
import AboutSection from './components/AboutSection';
import TestimonialsSection from './components/TestimonialsSection';
import CommunityUpdatesSection from './components/CommunityUpdatesSection';
import Footer from './components/Footer';
import StyleSwitcher from './components/StyleSwitcher';
import GoogleFormModal from './components/ui/GoogleFormModal';

// Create context for Google Form modal
export const GoogleFormModalContext = createContext();

// Custom hook to use Google Form modal
export const useGoogleFormModal = () => {
  const context = useContext(GoogleFormModalContext);
  if (!context) {
    throw new Error('useGoogleFormModal must be used within GoogleFormModalProvider');
  }
  return context;
};

function App() {
  const [isGoogleFormOpen, setIsGoogleFormOpen] = useState(false);

  const openGoogleFormModal = () => setIsGoogleFormOpen(true);
  const closeGoogleFormModal = () => setIsGoogleFormOpen(false);

  // Listen for custom event to open modal
  useEffect(() => {
    const handleOpenModal = () => openGoogleFormModal();
    window.addEventListener('openGoogleFormModal', handleOpenModal);
    return () => window.removeEventListener('openGoogleFormModal', handleOpenModal);
  }, []);

  return (
    <GoogleFormModalContext.Provider value={{ openGoogleFormModal, closeGoogleFormModal }}>
      <Layout>
        <StyleSwitcher />
        <Header />
        <HeroSection />
        <VisionMissionSection />
        <AboutSection />
        <CoreValuesSection />
        <StructureSection />
        <GuidingPrinciplesSection />
        <CallToActionSection />
        <CreativeCirclesSection />
        <MembershipSection />
        <PrinciplesCarousel />
        <TestimonialsSection />
        <CommunityUpdatesSection />
        <Footer />

        {/* Google Form Modal */}
        <GoogleFormModal
          isOpen={isGoogleFormOpen}
          onClose={closeGoogleFormModal}
        />
      </Layout>
    </GoogleFormModalContext.Provider>
  );
}

export default App;
